import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemText } from "@material-ui/core";
import React, {Component} from "react";

/**
 * purchase - закупка для которой нужно получить список магазинов для фильтрации.
 * filter_currentShopList - текущее состояние фильтра.
 * 
 * onSelectClick(filter_shop_list)
 * onCancelClick() 
 */

class FilterSelectShops extends Component {
    
    constructor(props) {
        
        super(props)

        this.state = {
            purchase_shopList: [{id: null, name: "Магазин не указан"}],
            filter_shopList: this.props.filter_currentShopList ? this.props.filter_currentShopList : []
        }

        // Получаем список магазинов используемых в закупке.

        for (let attachment of this.props.purchase.attachments) {
            let {shop} = attachment
            if (shop) {
                let f = this.state.purchase_shopList.find(shp => shp.id === shop.id)
                if (!f) {
                    this.state.purchase_shopList.push(shop)
                }
            }
        }

    }

    render() {
        return <Dialog open fullWidth>
            <DialogTitle>Выберите магазины</DialogTitle>
            <DialogContent>
                <List>
                    {this.state.purchase_shopList.map((shop, key) => <ListItem 
                        button
                        key = {key}
                        onClick={e => {
                            e.stopPropagation()
                            if (this.state.filter_shopList.find(s => s.id === shop.id)) {
                                this.setState({filter_shopList: this.state.filter_shopList.filter(s => s.id !== shop.id)})
                            } else {
                                this.state.filter_shopList.push(shop)
                                this.setState({filter_shopList: this.state.filter_shopList})
                            }
                        }}
                    >
                        <Checkbox checked={Boolean(this.state.filter_shopList.find(s => s.id === shop.id))} />
                        <ListItemText primary={shop.name}/>
                    </ListItem>)}
                </List>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={e => {
                        e.stopPropagation()
                        if (typeof this.props.onSelectClick === "function") {
                            this.props.onSelectClick(this.state.filter_shopList)
                        }
                    }}
                >Выбрать</Button>
                <Button 
                    onClick={e => {
                        e.stopPropagation()
                        if (typeof this.props.onCancelClick === "function") {
                            this.props.onCancelClick()
                        }
                    }}
                >Отмена</Button>
            </DialogActions>
        </Dialog>
    }
}

export default FilterSelectShops